export enum SessionProposalRoutes {
  Overview = '/overview',
  ChooseAccount = '/choose-account',
  ChooseNetwork = '/choose-network',
}
